// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import ReactDOM from 'react-dom'
// import registerServiceWorker from './registerServiceWorker';

// Import de Redux
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'
import history from './history'
import App from './components/App'
import store from './store.js'


// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'


ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'))

// registerServiceWorker();
